<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-29 14:52:20
 * @LastEditors: liyong
 * @LastEditTime: 2022-08-17 15:50:36
-->
<template>
	<div class="updateNotification" v-if="!bindStatus && !isClose">
		<div class="el-dialog__header flex-just-between flex">
			<span class="fz-16">系统升级通知！</span>
		</div>
		<div class="el-dialog__body">
			<p>
				<span class="yx-color-primary">为避免影响您的业务，请在2022-8-31&nbsp;前完成重新授权并关注公众号。</span>
				<span class="yx-color-text-primary"
					>小程序端迁移至&nbsp;【超汇选】且支持商务在移动端推品、查看推广记录，后续达人申样、物流进度消息将从&nbsp;【超汇选SaaS】&nbsp;公众号发送</span
				>
			</p>
			<div class="flex flex-just-center flex-align-center mt-16">
				<div
					v-loading="loading"
					element-loading-text="加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(112,112,112, 0.8)"
					element-loading-color="white"
					class="erweima"
				>
					<img :src="qrLink" alt="" />
				</div>
				<div class="yx-color-text-primary">
					<p>微信扫描二维码</p>
					<p>进行小程序授权</p>
				</div>
			</div>
			<el-button @click="closeDialog" class="iKnowBtn">我知道了</el-button>
		</div>
	</div>
</template>

<script>
import { checkUpNotice } from '@/api/common';
export default {
	data() {
		return {
			qrLink: '', //微信授权链接
			bindStatus: true, //是否微信授权
			loading: false,
			timer: null,
			isClose: false,
		};
	},
	created() {
		this.initCheck();
		this.pollCallBack();
	},
	methods: {
		//校验换绑超汇选小程序
		async initCheck() {
			this.loading = true;
			const { bind_status: bindStatus, qr_link: qrLink } = await checkUpNotice({});
			this.qrLink = qrLink;
			this.bindStatus = bindStatus;
			this.loading = false;
		},
		//轮询
		pollCallBack() {
			this.timer = setInterval(() => {
				setTimeout(async () => {
					const { bind_status: bindStatus } = await checkUpNotice({});
					this.bindStatus = bindStatus;
					if (this.bindStatus == false) return;
					clearInterval(this.timer);
				});
			}, 60000);
		},
		//关闭窗口结束轮询
		closeDialog() {
			this.isClose = true;
			clearInterval(this.timer);
		},
	},
};
</script>

<style lang="less" scoped>
.updateNotification {
	width: 400px;
	height: 374px;
	background-color: #fff;
	z-index: 2001;
	border: 1px solid #f8f8f8;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	.el-dialog__header {
		padding: 16px;
		align-items: center;
		font-weight: 500;
	}
	.el-dialog__body {
		padding: 12px 16px 16px !important;
	}
}
.erweima {
	width: 160px;
	height: 160px;
	margin-right: 45px;
}
/deep/ .el-loading-mask {
	border-radius: 10px !important;
}
/deep/ .el-loading-spinner .el-loading-text {
	color: #ffffff !important;
}
/deep/ .el-loading-spinner i {
	color: #ffffff !important;
}
.iKnowBtn {
	color: @color-primary;
	border-color: @color-primary;
	float: right;
	border-radius: 4px;
}
</style>
